"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { showNav: true };
        GState.bind(this, ['screen']);
    },
    onShowNav: function () {
        this.state.showNav = !this.state.showNav;
    },
    onToggleLink: function (...args) {
        this.emit('toggle-link', ...args);
        [
            'xs',
            'sm'
        ].includes(this.state.screen.media) && this.onShowNav();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/Progress.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Extension_template = require("../../../../../../../components/Extension/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Extension_tag = marko_loadTag(Extension_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    WSAdapt_template = require("../../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Bx_template = require("../../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-3 p-1 m-1 cursor-pointer"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const smallScreen = ['xs', 'sm'].includes( state.screen.media )

  if (state.showNav) {
    WSAdapt_tag({
        ns: "col-md-3 col-12",
        qs: "col-md-4 col-12",
        hs: "d-none",
        class: smallScreen ? "position-absolute zindex-1 animated slideInLeft faster" : "border-left",
        renderBody: function(out) {
          AutoScroll_tag({
              height: "100vh",
              class: "classroom-nav position-sticky theme-bg top-0",
              renderBody: function(out) {
                Extension_tag({
                    name: "ProgressPro",
                    payload: input.payload
                  }, out, __component, "2", [
                  [
                    "hide",
                    "onShowNav",
                    false
                  ],
                  [
                    "toggle-link",
                    "onToggleLink",
                    false
                  ],
                  [
                    "stats",
                    ( ...args ) => component.emit('stats', ...args ),
                    false
                  ],
                  [
                    "toggle-course",
                    ( ...args ) => component.emit('toggle-course', ...args ),
                    false
                  ]
                ]);
              }
            }, out, __component, "1");
        }
      }, out, __component, "0");
  } else {
    out.be("div", marko_attrs0, "3", component, null, 0, {
        onclick: __component.d("click", "onShowNav", false)
      });

    Bx_tag({
        type: "book-content",
        class: "font-large-1"
      }, out, __component, "4");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
